import { useLocation } from 'react-router-dom'

export const useIsActive = () => {
  const location = useLocation()

  function getIsActive(url: string) {
    // Normalize paths (remove trailing slashes)
    const normalizedPathname = location.pathname.replace(/\/$/, '') || '/'
    const normalizedUrl = url.replace(/\/$/, '') || '/'

    // Exact match
    if (normalizedPathname === normalizedUrl) {
      return true
    }

    // Check if pathname starts with url (for nested routes)
    // But make sure we match complete segments
    if (normalizedPathname.startsWith(normalizedUrl + '/')) {
      return true
    }

    return false
  }

  return getIsActive
}
